import React from "react";
import { motion } from "framer-motion";

const FeatureTab = ({ feature }) => {
  return (
    <div className="row gy-4">
      <div class="text-center mb-5">
        <span class="badge  badge-journey text-primary">Benefits</span>
        <h2 class="display-6 fw-bold text-primary mb-3">
          Transform Your Business
        </h2>
        <p class="lead text-muted mx-auto fw-500">
          Experience measurable improvements and growth with our expert
          solutions.
        </p>
      </div>
      {feature.map((feat, idx) => {
        const IconComp = feat.icon;
        return (
          <motion.div
            className="col-md-4"
            key={idx}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="card h-100 shadow-sm text-center p-4">
              <div className="mb-3">
                <IconComp size={32} className="text-primary" />
              </div>
              <h5 className="card-title">{feat.name}</h5>
              <p className="card-text">{feat.description}</p>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default FeatureTab;
